module.exports = __webpack_public_path__ + "static/data-8e2ab2e42116967fd8d721587072d5ae.svg";